
import React from "react";
import "../../Styles/certified/illumine.css";

export default function illumine() {
  return (
    <>
      <div className="illumine-details-section">
        <div className="illumine-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="illumine-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="illumine-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="illumine-badge"
            />
            <div className="illumine-company-names">
              <a href="https://www.illuminei.com/" target="_blank" rel="noopener noreferrer"><img src="/assets/illu/illumine_logo.png" alt="illumine.png" className="illumine-company-logo" /></a>
              <h1 className="illumine-full-name">
                Illumine Industries Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="illumine-details-right">
            <img
              src="/assets/illu/illu_1.png"
              alt="illumine Office"
              className="illumine-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="illumine-description">
          <h2>
            Why Illumine Industries Private Limited is a Outstanding Workplaces
          </h2>
          <p>
        Illumine Industries Private Limited (Illumine-i) is a sustainable design and engineering company specializing in renewable energy, power infrastructure, and construction engineering solutions. It was founded in 2015 and has grown into a global engineering firm with offices in India and the United States, supporting projects across multiple continents. The company focuses on creating efficient, technology-driven Engineering solutions for solar, energy storage, EV charging, BESS, Substation and Utility Scale Projects. 
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="illumine-info-cards">
          <div className="illumine-info-card">
            <div className="illumine-info-title">COMPANY SIZE</div>
            <div className="illumine-info-value">150 Employees</div>
          </div>
          <div className="illumine-info-card">
            <div className="illumine-info-title">INDUSTRY</div>
            <div className="illumine-info-value">Engineering Consulting - Power Engineering (Clean Energy)</div>
          </div>
          <div className="illumine-info-card">
            <div className="illumine-info-title">CONNECT</div>
            <div className="illumine-info-icons">
              <span className="illumine-icon-round">
                <a href="https://www.illuminei.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="illumine-icon-round">
                <a href="https://www.linkedin.com/company/illumine-industries/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="illumine-icon-round">
                <a href="https://www.facebook.com/illumineiindustries/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
             
            </div>
          </div>
          <div className="illumine-info-card">
            <div className="illumine-info-title">LOCATION (HQ)</div>
            <div className="illumine-info-value">Chennai, Tamilnadu</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="illumine-recognition-section">
          <h2 className="illumine-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="illumine-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="illumine-recognition-image"
            />
          </div>
          <div className="illumine-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at illumine Section */}
        <div className="illumine-life-section">
          <h2 className="illumine-life-title">
            Life at Illumine Industries Private Limited
          </h2>
          <div className="illumine-life-gallery">
            <div className="illumine-life-col">
              <img src="/assets/illu/illu_2.jpg" alt="Office 1" className="illumine-life-img" />
              <img src="/assets/illu/illu_3.png" alt="Meeting 1" className="illumine-life-img" />
            </div>
            <div className="illumine-life-col illumine-life-center">
              <img src="/assets/illu/illu_1.png" alt="Main Office" className="illumine-life-img illumine-life-img-large" />
            </div>
            <div className="illumine-life-col">
              <img src="/assets/illu/illu_4.png" alt="Office 2" className="illumine-life-img" />
              <img src="/assets/illu/illu_5.jpg" alt="Meeting 2" className="illumine-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}